import React, { useState } from 'react';
import { graphql, useStaticQuery} from "gatsby";
import Img from "gatsby-image"
import {Link, useI18next, I18nextContext} from 'gatsby-plugin-react-i18next';

import { Link as ScrollToLink } from 'react-scroll'
import styled from "styled-components"
import SectionHeader from './section-header';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';

import { FaFilePdf, FaFileDownload } from 'react-icons/fa';

import { Document, Page, pdfjs, PDFDownloadLink } from 'react-pdf';
import Download from '@axetroy/react-download';

import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import IconButton from '@material-ui/core/IconButton';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';
 
import PresentationsModal from './presentations-modal';
// import backgroundImage from '../images/AdobeStock_129920476_Preview-color-orange.jpg'
import backgroundImage from '../images/background-books.jpg'

const Container = styled.div`
    width: 100%;
    min-height: calc(100vh - 40px);
    // padding-top: 60px;
    text-align: center;
    // background: #ACD433;
    // background: #2c466b;
    // color: wheat;
    // margin-top: 15px;
    margin: 0 auto;
    margin-top: -131px;
    padding-top: 131px;
    // background-color: white;
    // background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3Crect stroke='%23ffffff' stroke-width='.5' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='scale(14.6) translate(-931.51 -698.63)'%3E%3Cuse fill='%23fafafa' href='%23s' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='2'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='scale(14.6) translate(-931.51 -698.63)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(14.6) translate(-931.51 -698.63)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(14.6) translate(-931.51 -698.63)'%3E%3Cg fill='%23e5e5e5'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='scale(14.6) translate(-931.51 -698.63)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%23e0e0e0'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='scale(14.6) translate(-931.51 -698.63)'%3E%3Cg fill='%232c4666'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='scale(14.6) translate(-931.51 -698.63)'%3E%3Cg fill='%232c4666'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='scale(14.6) translate(-931.51 -698.63)'%3E%3Cg fill='%232c4666'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E");
   
    // background-color: #20466b;
    // background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3Crect stroke='%23204666' stroke-width='.5' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cuse fill='%23244a69' href='%23s' y='2'/%3E%3Cuse fill='%23244a69' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23294d6c' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23294d6c' href='%23s'/%3E%3Cuse fill='%232d516f' href='%23s' x='2'/%3E%3Cuse fill='%232d516f' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23325572'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23325572'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23365975'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23204666'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%233b5c78'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23eaf1f3'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23eaf1f3'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='scale(50) translate(-980 -735)'%3E%3Cg fill='%23eaf1f3'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E");

    background-image: url(${(props)=>props.backgroundImage});
    background-attachment: fixed;
    background-size: cover;
    background-repeat: no-repeat;
`

const Section = styled.div`
    
`


const ContentWrapper = styled.div`
    margin: 0 auto;
    text-align: center;
    background-color: ${props=>props.$backgroundColour};
    color: ${props=>props.$colour};
    padding-top: 60px;
    padding-bottom: 60px;
    
    @media screen and (max-width: 1220px) {
        padding-top: 90px;
    }
`

const ContentInner = styled.div`
    width: 73.306%; // with sidebar
    // width: auto;
    margin: 0 auto;
    // float: left;
    
    margin-left: 0;
    margin-right: 0;
    
    @media screen and (max-width: 767px) {
        width: 95%;
    }
    
   

`

const ArticlesContainer = styled.div`
    display: flex;
    flex-direction: column;
`

const Article = styled.div`
    display: flex;
    margin-top: 16px;
    margin-bottom: 16px;
    background: white;
    padding: 32px;
    
    @media screen and (max-width: 1100px) {
        padding: 16px;
    }
    
    @media screen and (max-width: 900px) {
        
    }
`

const ArticleInner = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    
    h1 {
        text-align: left;
        
        // &:hover {
        //     color: #ff8000;
        // }
        
        @media screen and (max-width: 767px) {
            font-size: 20px;
        }
    }
    
    h2 {
        text-align: left;
        font-weight: 100;
    }
    
    ul {
        text-align: left;
        font-size: 18px;
        list-style-position: inside;
    }
`


const BookCoverWrapper = styled.div`
    width: 30%;
    overflow: hidden;
    
    
    &.to-the-left {
        float: left;
        margin-right: 16px;
    }
    
    &.to-the-right {
        float: right;
        margin-left: 16px;
    }
    
    img {
        width: 100%;
        height: auto;
        object-fit: cover;
        object-position: center;
    }
`

const TitleWrapper = styled.div`
    margin-bottom: 16px;
`
const ArticleButton = styled(Button)`
    width: 160px
`

const SideBar = styled.div`
    float: right;
    width: 25%;
    
`

const ArticleCollection = styled.div`
    background: white;
    padding: 16px;
    margin-top: 16px;
    
    // cursor: pointer;
    
    
    h3 {
        text-align: left;
        margin-bottom: 16px;
        font-weight: 400;
        font-size: 18px;
        
        &:hover {
           // color: #ff8000;
            color: rgb(44,70,107);
            -webkit-text-stroke: 0;
            -webkit-text-stroke-color: none;
            -webkit-text-stroke-width: 0;
        }
    }
`

const Content = styled.div`
    margin: 0 auto;
    margin-top: 40px;
    width: 90%;
    max-width: 90%;
    max-width: 1372px;
    display: flex;
    // justify-content: space-between;
    justify-content: center;
    
    p { 
        
        font-size: 18px;
        line-height: 1.4;
        // margin-top: 14px;
        font-weight: 400;
        white-space: pre-wrap;
        margin-bottom: 14px;
        text-align: left;
    }
    
  
`

const BookCollection = styled.div`
    position: sticky;
    top: 106px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 16px;
    
    a {
        width: 24%;
        width: 85px;
        // height: 120px;
        margin-left: 5px;
        margin-bottom: 5px;
        cursor: pointer;
        
        .gatsby-image-wrapper {
            height: 125px;
        }
        
        img {
            width: auto;
            height: 100%;
            object-fit: cover;
        }
    }

`

const ReadMoreUrl = styled.div`
    width: auto;
    text-align: left;
    font-size: 18px;
`

const DownloadLinkWrapper = styled.div`
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    margin-bottom: 20px;
    
    @media screen and (max-width: 767px) {
        font-size: 15px;
    }
`


const ButtonWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    margin-left: -4px;
    overflow: hidden;
`
const StyledIconButton = styled(IconButton)`
    background-color: #2c466b;
    color: white;
    width: max-content;
    width: 100%;
    padding: 6px;
    border-radius: 0;
    // margin-left: 10px;
    // margin-right: 10px;
    height: 100%;
    flex: 1;
    font-size: 18px;
    // margin: 4px;
    
    &.Mui-disabled {
        background: lightgray;
    }
    &:hover {
        background-color: #2c466b;
        color: #ff8000;
    }
`

const StyledPagerButton = styled(IconButton)`
    background-color: #2c466b;
    color: white;
    width: max-content;
    padding: 6px;
    border-radius: 0;
    margin-left: 10px;
    margin-right: 10px;
    height: 100%;
    
    &.Mui-disabled {
        background: lightgray;
    }
    &:hover {
        background-color: #2c466b;
        color: #ff8000;
    }
`

const Pager = styled.div`
    display: flex;
    justify-content: center;
`

const StyledDocument = styled(Document)`
    canvas {
        max-width: 100%!important;
        object-fit: contain!important;
        height: auto!important;
        
    }
`

const PresentationsContent = () => {

    const context = React.useContext(I18nextContext);
    
    const {t} = useI18next();
    const language = context.language;
    
    const items = useStaticQuery(graphql`
      query{
        allMarkdownRemark(filter: {fileAbsolutePath: {regex: "/(presentations)/"}}, sort: {fields: frontmatter___date, order: DESC}) {
          edges {
            node {
              frontmatter {
                title
                subtitle
                presentationTitle
                file
                date
                language
              }
              html
              id
            }
          }
        }
      }
    `)
    let edges = items.allMarkdownRemark.edges
    let presentationsFilteredByLanguage = edges.filter(edge=>edge.node.frontmatter.language === language)
    
    return (
        <Container backgroundImage={backgroundImage}>
        {console.log("Context: ", context)}
        {console.log(items)}
        {console.log(presentationsFilteredByLanguage)}
       
            <ContentWrapper id="mission" >
                <SectionHeader id="section-header" title={t("PUBLICATIONS.PRESENTATIONS")}/>
                <Content>
                    <ContentInner>
                        <ArticlesContainer>
                            {
                                presentationsFilteredByLanguage.map((presentation, index)=>{
                                    return (
                                        <Article id={presentation.node.id} key={presentation.node.id}>
                                            <ArticleInner>
                                                <TitleWrapper>
                                                    <h1>{presentation.node.frontmatter.title}</h1>
                                                    <p>{presentation.node.frontmatter.subtitle} — {presentation.node.frontmatter.date}</p>
                                                </TitleWrapper>
                                                <div>
                                                    <div dangerouslySetInnerHTML={{__html: presentation.node.html}} />
                                                </div>
                                                <PresentationsModal pdf={presentation.node.frontmatter.file} presentationTitle={presentation.node.frontmatter.presentationTitle} openAnchorText={presentation.node.frontmatter.openAnchorText} />

                                            </ArticleInner>
                                        </Article>
                                    )
                                })
                            }
                        </ArticlesContainer>
                        
                    </ContentInner>
                    {/*<SideBar>
                            <ArticleCollection>
                                {
                                    presentationsFilteredByLanguage.map((presentation)=>{
                                        return (
                                  
                                            <ScrollToLink key={presentation.node.id} to={presentation.node.id} spy={true} smooth={true} offset={-105} duration={1000}>
                                                <h3>{presentation.node.frontmatter.title}</h3>
                                            </ScrollToLink>
                                        
                                        )
                                    })
                                }
                            </ArticleCollection>
                        </SideBar>*/}
                </Content>
            </ContentWrapper>
        </Container>
    
    )
}

export default PresentationsContent